import { render } from "./SettingsLoadingButton.vue?vue&type=template&id=27d88238"
import script from "./SettingsLoadingButton.vue?vue&type=script&lang=js"
export * from "./SettingsLoadingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SettingsLoadingButton.vue"]])

export default __exports__